<template>
  <div class="card border-0 rounded-0">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div class="card-header">
        <h3 class="text-black fw-semibold">Détails d'un produit</h3>

        <router-link to="/produits/liste-produits" class="btn btn-primary text-black transition border-0 lh-1 fw-medium"
          style="position: absolute; right: 10px; top: 10px;">
          <i class="flaticon-left-arrow lh-1 me-1"></i>
          Retour
        </router-link>
      </div>
      <div class="card-head box-shadow bg-white d-flex align-items-center justify-content-between"></div>
      <div class="row">
        <!-- Bloc des informations générales -->
        <div class="col-md-8 col-xxl-8 col-sm-12 p-0">
          <h4 class="text-black fw-bold mb-10">Informations générales</h4>
          <table class="table">
            <tbody>
              <tr>
                <td>Code Produit</td>
                <td>{{ produit?.codeProduit }} </td>
              </tr>
              <tr>
                <td>Référence</td>
                <td>{{ produit?.refProd }} </td>
              </tr>
              <tr>
                <td>Famille</td>
                <td>{{ produit?.famille?.libelleFamille }}</td>
              </tr>
              <tr>
                <td>Nom</td>
                <td>{{ produit?.nomProd }}</td>
              </tr>

              <tr v-if="produit?.uniteGestion">
                <td>Unité de gestion:</td>
                <td>{{ produit?.uniteGestion?.libelle }}</td>
              </tr>
              <tr v-if="produit?.uniteStock">
                <td>Unité de Stock:</td>
                <td>{{ produit?.uniteStock?.libelle }}</td>
              </tr>
            </tbody>
          </table>
          <div v-if="produit?.descProd" class="mb-4">
            <h5 class="text-black fw-bold mt-4">Description du produit</h5>
            <p>{{ produit?.descProd }}</p>
          </div>

          <!-- Tableau des conditionnements -->
          <div class="row">
            <div class="col">
              <h5 class="text-black fw-bold mt-4">Conditionnements du produit</h5>
            </div>
            <div class="col">
              <router-link :to="{ name: 'AddProduitConditionnement', params: { id: produit?.id } }"
                class="btn btn-primary text-black mt-3 text-center">
                <i class="fa fa-plus-circle lh-2 me-8 position-relative top-1"></i> Compléter un conditionnement
              </router-link>
            </div>
          </div>
          <table class="table">
            <thead>
              <tr>
                <th>Conditionnement</th>
                <th>Qté Condit.</th>
                <th>UM</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(produitconditionnement, index) in produit?.produitconditionnements" :key="index">
                <td>{{ produitconditionnement.conditionnement?.libelle }}</td>
                <td>{{ produitconditionnement.qteCond }}</td>
                <td>{{ produitconditionnement.conditionnement2?.libelle }}</td>
                <td>
                  <div v-if="index !== 0"> <!-- Ajout de la condition ici -->
                    <span class="">
                      <a class="bullet me-3 btn f-w-500 background-light-danger font-danger" href="javascript:void(0);"
                        @click="suppression(produitconditionnement.id, produit?.produitconditionnements, 'produitconditionnement', `le conditionnement ${produitconditionnement.conditionnement.libelle}`)">
                        <i class="fa fa-trash-o lh-2 me-8 position-relative top-1"></i>
                      </a>
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

        </div>

        <div class="col-md-4 col-xxl-4 col-sm-12 p-0">
          <h5 class="text-black fw-bold mb-10">Image du Produit</h5>

          <hr> <!-- Petit trait séparateur -->
          <img v-if="produit?.imagePrincipal" :src="getUrlApiForProductFiles(produit?.imagePrincipal)"
            class="d-block w-100" alt="Photo">
          <hr>
          <div v-if="medias.length > 0" id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">

            <div class="carousel-inner">
              <div class="carousel-item" :class="index == 0 ? 'active' : ''" v-for="(media, index) in medias"
                :key="index">
                <img :src="getUrlApiForProductFiles(media.nomMedia)" class="d-block w-100" alt="Photo">
              </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
              data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Précédent</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
              data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Suivant</span>
            </button>
          </div>
          <div v-else>
            <img :src="getUrlApiForProductFiles(null)" class="d-block w-100" alt="Photo">
          </div>
        </div>

      </div>
    </div>
  </div>




</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/services/ApiService";
import { Produit } from "@/models/Produit";
import { error, getUrlApiForProductFiles, suppression, success } from "@/utils/utils";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "ViewProduit",
  components: {


  },
  setup() {
    const route = useRoute();
    const produit = ref<Produit | null>(null);
    const medias = ref([]);

    async function getProduit(id: string) {
      try {
        const { data } = await ApiService.get(`/produits/${id}`);
        console.log(data);
        if (data && data.data) {
          produit.value = data.data;
          medias.value = data.data.medias; // Récupération des médias du produit
        } else {
          throw new Error("Données du produit non trouvées.");
        }
      } catch (err) {
        error(err instanceof Error ? err.message : "Erreur lors de la récupération du produit.");
      }
    }
    const selectedProduit = ref<Produit | undefined>(undefined);
    const selectedProduitId = ref<number>();




    const reloadUserData = () => {
      getProduit(route.params.id as string);
    };

    onMounted(() => {
      const id = route.params.id as string;
      if (id) {
        getProduit(id);
      } else {
        error("ID du produit non spécifié.");
      }
    });

    return {
      produit,
      medias, suppression, reloadUserData,
      getUrlApiForProductFiles,
      selectedProduitId, selectedProduit

    };
  },
});
</script>

<style scoped>
.card {
  border: none;
  /* Retire la bordure */
  margin: 0;
  /* Enlève toutes les marges */
}

.card-body {
  padding: 15px;
  /* Ajustez le padding pour vos besoins */
}

/* Enlève la marge entre les colonnes */
.row {
  margin: 0;
  /* Retire l'espacement de la rangée */
}

/* Ajout d'un petit espacement seulement avec un trait séparateur */
.table {
  border-collapse: collapse;
}

.table td {
  padding: 8px;
}

.carousel-inner img {
  max-height: 400px;
  object-fit: cover;
}
</style>
